import * as Yup from 'yup';

import { API_NAME_MAX_CHAR } from 'src/lib/graphOnboarding/constants';
import { isLocalUrl } from 'src/lib/isLocalUrl';
import { isValidUrl } from 'src/lib/isValidUrl';

export const addSchemaModalErrorMessages = {
  routingUrl: {
    required: 'Please provide a routing URL.',
    validUrl: 'Please enter a valid URL.',
    localUrl:
      'Your routing URL needs to be available on the public internet. If you would like to fetch a schema from a local endpoint, enter it below.',
  },
  subgraphName: {
    required: 'Please provide a name for your Subgraph.',
    min: 'Subgraph name must be at least 2 characters.',
    max: `Subgraph name must be at most ${API_NAME_MAX_CHAR} characters.`,
    startWithLetter: 'Subgraph name must start with a letter.',
    contents: 'Subgraph name may only contain letters, numbers, and dashes.',
  },
  sdl: {
    valid:
      "We couldn't parse that schema. Please check that you added the right file or that it pasted correctly.",
    success: 'Your schema is good to go!',
  },
  localEndpointUrl: {
    localUrl:
      'This is not a local url. If your endpoint is deployed, use the endpoint field above.',
  },
};

export const addSchemaValidationSchema = Yup.object().shape({
  // this is in this validation schema to make subgraphName optional
  // conditionally, it should never be set
  isFederated: Yup.boolean(),
  // This sdl is the introspected document or manual sdl upload
  sdl: Yup.string().required(),
  routingUrl: Yup.string()
    .required(addSchemaModalErrorMessages.routingUrl.required)
    .test(
      'valid-http-url',
      addSchemaModalErrorMessages.routingUrl.validUrl,
      (value: string) => !value || isValidUrl(value),
    ),
  subgraphName: Yup.string().when('isFederated', (isFederated) =>
    isFederated
      ? Yup.string()
          .required(addSchemaModalErrorMessages.subgraphName.required)
          .min(2, addSchemaModalErrorMessages.subgraphName.min)
          .max(API_NAME_MAX_CHAR, addSchemaModalErrorMessages.subgraphName.max)
          .matches(
            /^[a-zA-Z]/,
            addSchemaModalErrorMessages.subgraphName.startWithLetter,
          )
          .matches(
            /^[a-zA-Z0-9_-]*$/,
            addSchemaModalErrorMessages.subgraphName.contents,
          )
      : Yup.string(),
  ),
  localEndpointUrl: Yup.string()
    .test(
      'valid-http-url',
      addSchemaModalErrorMessages.routingUrl.validUrl,
      (value: string) => !value || isValidUrl(value),
    )
    .test(
      'is-local-url',
      addSchemaModalErrorMessages.localEndpointUrl.localUrl,
      (value: string) => !value || isLocalUrl(value),
    ),
});
